/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: Pholo (https://sketchfab.com/Pholothe1)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/chair-low-poly-3775963c1d6d4ba1b37956a4fb423add
title: Chair Low Poly
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Chair({ ...props }) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/scene.gltf')
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-0.9, -2, 0.5]} rotation={[Math.PI / 2, 0, 0]} scale={0.1}>
        <group rotation={[-Math.PI, 0, 0]}>
          <group position={[0, 0, 0]} rotation={[Math.PI / 2, Math.PI / 2, 0]} scale={0.36}>
            <mesh geometry={nodes.Mesh_lambert2_0.geometry} material={materials.lambert2} />
            <mesh geometry={nodes.Mesh_lambert3_0.geometry} material={materials.lambert3} />
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/scene.gltf')
